import { ActivityLogState } from './partials/activity-log'
import { AssociateRecordState } from './partials/associate-records'
import { PrintRecordState } from './partials/print-record'
import { RecordEditState } from './partials/edit'

export const virginRecord = {
  id: null,
  opened: null,
  team_ids: [],
}

export const RecordState = _ => ({
  ...ActivityLogState,
  ...AssociateRecordState,
  ...PrintRecordState,
  ...RecordEditState,

  isSearching: false,
  record: null,
  records: [],
})
